enum FileInformationStatus {
    UPLOADING = 'uploading',
    VERIFIED = 'verified',
    ERROR_CREATING_FILE_FORM_INTENT = 'error_creating_file_form_intent',
    ERROR_FILE_UPLOADING_TO_S3 = 'error_file_uploading_to_s3',
    ERROR_FILE_VERIFICATION = 'error_file_verification',
}

export default FileInformationStatus;
